import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterNoordhoek() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-noordhoek",
    name: "Painters Noordhoek",
    location: "Noordhoek, Cape Town",
    rating: 4.9,
    reviews: 152,
    specialties: ["Luxury Homes", "Coastal Estates", "Mountain Properties", "High-End Finishes"],
    image: "https://public.readdy.ai/ai/img_res/7cc7ad60f4728dd129ae1f73e962d019.jpg",
    verified: true,
    yearsExperience: 17,
    website: "https://paintersnoordhoek.co.za",
    email: "info@paintersnoordhoek.co.za",
    phone: "+27 21 555 0134",
    description: "Professional painting services in Noordhoek and surrounding coastal areas. We specialize in luxury homes and coastal estates with expertise in high-end finishes that withstand mountain and ocean conditions.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Luxury Estate Painting",
      "Coastal Property Painting",
      "Roof Painting & Coatings",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Noordhoek", "Kommetjie", "Chapman's Peak", "Hout Bay", "Sun Valley", "Fish Hoek", "Atlantic Seaboard"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Noordhoek%20Cape%20Town%2C%20luxury%20coastal%20home%20with%20fresh%20painted%20walls%20and%20Chapmans%20Peak%20mountain%20views%2C%20quality%20paint%20finish%2C%20Atlantic%20Ocean%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20high-end%20furniture%20and%20elegant%20decor&width=400&height=300&seq=noordhoek-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20luxury%20estate%20painting%20project%20in%20Noordhoek%20Cape%20Town%20South%20Africa%2C%20coastal%20home%20with%20fresh%20paint%20overlooking%20Atlantic%20Ocean%20and%20mountains%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20beachfront%20setting%20with%20Chapmans%20Peak%20views%2C%20well-maintained%20luxury%20property%20with%20beautiful%20landscaping&width=400&height=300&seq=noordhoek-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Luxury%20coastal%20estate%20painting%20project%20in%20Noordhoek%20Chapmans%20Peak%2C%20professional%20painters%20working%20on%20high-end%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20modern%20luxury%20architecture%20with%20ocean%20and%20mountain%20views%2C%20organized%20work%20site%20with%20premium%20painting%20equipment%20and%20materials&width=400&height=300&seq=noordhoek-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Noordhoek%20luxury%20coastal%20home%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20modern%20gourmet%20kitchen%2C%20quality%20paint%20finish%20with%20elegant%20color%20scheme%2C%20bright%20clean%20space%20with%20ocean%20and%20mountain%20views%2C%20professional%20painting%20work%20with%20high-end%20fixtures%20and%20designer%20appliances&width=400&height=300&seq=noordhoek-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20interior%20painting%20in%20Noordhoek%20luxury%20beachfront%20estate%2C%20fresh%20painted%20walls%20in%20spacious%20bedroom%2C%20modern%20coastal%20design%20with%20Atlantic%20Ocean%20and%20Chapmans%20Peak%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20elegant%20decor%20and%20natural%20lighting&width=400&height=300&seq=noordhoek-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20luxury%20coastal%20estate%20painting%20in%20Noordhoek%20Cape%20Town%2C%20professional%20painters%20applying%20premium%20marine-grade%20paint%20to%20high-end%20property%2C%20Atlantic%20Ocean%20and%20Chapmans%20Peak%20mountain%20backdrop%2C%20quality%20exterior%20finish%20with%20weather%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment&width=400&height=300&seq=noordhoek-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Richard Blackwood",
        rating: 5,
        comment: "Outstanding work on our Noordhoek estate. The team was highly professional and delivered exceptional quality. They understand luxury coastal properties and the unique challenges of this area."
      },
      {
        name: "Catherine van der Merwe", 
        rating: 5,
        comment: "Excellent service from start to finish. They completed our luxury home painting on schedule and the quality is impeccable. Highly recommend for high-end properties in Noordhoek."
      },
      {
        name: "James Peterson",
        rating: 5,
        comment: "Professional painters who truly understand luxury coastal estates. Great attention to detail and the finish has held up perfectly against the harsh mountain and ocean conditions."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Noordhoek | Professional Luxury Painting Services Cape Town | Coastal Estate Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Painters Noordhoek offers professional painting services for luxury homes and coastal estates in Noordhoek, Cape Town. Specializing in high-end finishes, marine-grade coatings, and Chapman's Peak properties.");
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', "Painters Noordhoek, luxury house painters Noordhoek, coastal estate painting Cape Town, high-end property painting, Chapman's Peak painters");
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20luxury%20coastal%20estate%20in%20Noordhoek%20Cape%20Town%20South%20Africa%2C%20spectacular%20Atlantic%20Ocean%20views%20with%20Chapmans%20Peak%20mountain%20backdrop%2C%20painters%20in%20clean%20uniforms%20applying%20premium%20paint%20with%20brushes%20and%20rollers%2C%20modern%20luxury%20architecture%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment&width=1200&height=600&seq=noordhoek-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters Noordhoek
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Premium Painting Services for Luxury Coastal Estates
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Noordhoek's premier painting contractors specializing in luxury homes, coastal estates, and mountain properties. With over 17 years of experience serving the Southern Peninsula, we deliver exceptional craftsmanship and high-end finishes that withstand the unique coastal and mountain climate conditions of this prestigious area.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters Noordhoek</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters Noordhoek, the Southern Peninsula's most trusted painting contractor for luxury residential properties. For over 17 years, we have been the preferred choice for discerning homeowners in Noordhoek, Kommetjie, Chapman's Peak, Hout Bay, and surrounding coastal areas who demand nothing but the finest in painting craftsmanship and service excellence.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been built on a foundation of exceptional quality, meticulous attention to detail, and an unwavering commitment to customer satisfaction. We understand that your home is your most valuable investment, and we treat every project with the care and professionalism it deserves. Whether you own a luxury coastal estate with breathtaking ocean views, a mountain retreat nestled against the dramatic Chapman's Peak, or a contemporary architectural masterpiece, our team has the expertise and experience to enhance and protect your property.
                        </p>
                        <p className="leading-relaxed">
                          What sets Painters Noordhoek apart is our deep understanding of the unique environmental challenges faced by properties in this spectacular but demanding coastal and mountain environment. The combination of salt-laden ocean breezes, intense UV radiation, strong winds, and occasional mountain mists requires specialized knowledge, premium materials, and proven techniques. Our team is expertly trained in selecting and applying the most appropriate coatings and finishes to ensure your property not only looks stunning but remains protected for years to come.
                        </p>
                        <p className="leading-relaxed">
                          We pride ourselves on our comprehensive approach to every project. From the initial consultation and color selection through to surface preparation, application, and final inspection, we maintain the highest standards at every stage. Our painters are not just skilled tradespeople; they are craftsmen who take genuine pride in their work and understand the importance of delivering flawless results that exceed expectations.
                        </p>
                        <p className="leading-relaxed">
                          Our extensive portfolio includes some of the most prestigious properties in the Southern Peninsula. We have worked on everything from multi-million rand coastal estates to charming beach cottages, from contemporary architectural statements to classic Cape Dutch homesteads. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of size or scope.
                        </p>
                        <p className="leading-relaxed">
                          At Painters Noordhoek, we believe in building lasting relationships with our clients. Many of our customers have been with us for years, trusting us with their ongoing maintenance and renovation projects. This loyalty is a testament to our consistent delivery of superior results, transparent communication, and fair pricing. We understand that having contractors work in your home requires trust, and we never take that responsibility lightly.
                        </p>
                        <p className="leading-relaxed">
                          Our commitment to excellence extends beyond the quality of our painting work. We maintain clean, organized work sites, respect your property and privacy, and work efficiently to minimize disruption to your daily life. We use only premium, environmentally responsible paints and materials from leading manufacturers, ensuring both beautiful results and long-lasting protection for your investment.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters Noordhoek?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">17+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Nearly two decades of proven excellence in luxury coastal property painting throughout the Southern Peninsula.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-star-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Premium Quality Materials</h4>
                            <p className="text-gray-600 text-sm">We use only the finest marine-grade and UV-resistant paints specifically formulated for coastal environments.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Exceptional Customer Service</h4>
                            <p className="text-gray-600 text-sm">Transparent communication, respect for your property, and a commitment to exceeding your expectations.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters Noordhoek proudly serves the entire Southern Peninsula region, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Noordhoek', 'Kommetjie', "Chapman's Peak", 'Hout Bay', 'Sun Valley', 'Fish Hoek', 'Scarborough', 'Misty Cliffs', 'Ocean View'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters Noordhoek, we offer a complete range of professional painting services tailored to the unique needs of luxury coastal and mountain properties. Our expertise covers every aspect of residential painting, from initial consultation through to final inspection and beyond.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Luxury Interior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your living spaces with our premium interior painting services. We specialize in high-end finishes, designer color palettes, and specialty techniques including faux finishes, textured walls, and decorative painting. Our meticulous surface preparation ensures flawless results that enhance your home's beauty and value.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living rooms, bedrooms, and entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Kitchens and bathrooms with moisture-resistant coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, trim, doors, and architectural details</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Specialty finishes and decorative techniques</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-building-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Coastal Exterior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Protect and beautify your property's exterior with our specialized coastal painting services. We use premium marine-grade paints and proven application techniques designed to withstand salt spray, UV radiation, and harsh weather conditions. Our comprehensive approach includes thorough surface preparation, repairs, and protective coatings.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior walls with marine-grade coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Windows, doors, and trim work</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Decks, patios, and outdoor living areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Fascias, soffits, and gutters</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-shield-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Waterproofing & Protection</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Essential for coastal properties, our comprehensive waterproofing services protect your investment from moisture damage, mold, and structural deterioration. We use advanced waterproofing systems and sealants specifically designed for the challenging Southern Peninsula climate.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior wall waterproofing and sealing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Roof waterproofing and coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Balcony and deck waterproofing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Damp proofing and moisture barrier installation</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-paint-brush-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Specialty Coatings & Finishes</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Enhance your property with our range of specialty coatings and high-end finishes. From UV-resistant clear coats to textured finishes and decorative effects, we have the expertise to create unique, stunning results that reflect your personal style and protect your investment.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant protective coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Textured and decorative finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Wood staining and varnishing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Metal coating and rust prevention</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Sidebar */}
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20luxury%20coastal%20estate%20in%20Noordhoek%20Cape%20Town%2C%20Atlantic%20Ocean%20and%20Chapmans%20Peak%20mountain%20property%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20modern%20luxury%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=noordhoek-sidebar-image&orientation=landscape"
                    alt="Professional painters Noordhoek luxury estate painting services Cape Town Chapman's Peak"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
